const sgyConsumer = {
    type: 0,
    age: 30,
    sex: "M",
    taxfree: false,
    taxfreePreservationAge: 55,
    startSal: 50000,
    startBal: 50000,
    startBalTaxfree: 0,
    startContr: 0,
    salPack: false,
    salPackDollar: 0,
    salPackPerc: 0,
    salInflation: 0.04,
    contributionRule: 1,
    afterTax: true,
    afterTaxDollar: 0,
    afterTaxPerc: 0,
    onceOffContNonConc: true,
    onceOffContNonConcDollar: 0,
    bringForwardRule: false,
    beforeTax: true,
    beforeTaxDollar: 0,
    beforeTaxPerc: 0,
    onceOffContConc: true,
    onceOffContConcDollar: 0,
    includeSuperCoCont: true,
    totalNonConcContributionBefore2007: 0,
    workforceBreak: false,
    workforceBreakYears: 0,
    workforceBreakAge: 55,
    workforceBreakSalPerc: 1,
    retireLumpSumDollar: 0,
    retireDesiredIncome: 51630,
    retireCoupleDesiredIncome: 72663,
    retireAge: 67,
    retireIncludePension: true,
    retireHomeOwner: true,
    retireAgePensionQualificationAge: 67,
    retireAgePensionPreservationAge: 60,
    retireWorkIncome: 0,
    retireWorkUntilAge: 75,
    retireOtherIncome: 0,
    retireFinancialAssets: 0,
    retireOtherAssets: 0,
    assumSuperEarningsTaxPerc: 0.0,
    assumSGCContPerc: 0.115,
    assumSuperContTaxPerc: 0.15,
    assumSuperContTaxPerc300: 0.3,
    assumAccumulationInflation: 0.04,
    assumPensionInflation: 0.025,
    assumFBTPerc: 0.49,
    feeSuperAssetPerc: 0.0058,
    feeSuperAssetMin: 0,
    feeSuperAssetCap: 9999999,
    feeSuperFixedDollar: 0,
    feeSuperInsurance64: 0,
    feeSuperInsurance69: 0,
    feeSuperInsurance70: 0,
    feeSuperContributionBasedPerc: 0,
    feePensionAssetPerc: 0.0058,
    feePensionAssetMin: 0,
    feePensionAssetCap: 9999999,
    feePensionFixedDollar: 78,
    feeTTRAssetPerc: 0.0058,
    feeTTRAssetMin: 0,
    feeTTRAssetCap: 9999999,
    feeTTRFixedDollar: 78,
    includeTTR: false,
    ttrStartAge: 60,
    ttrStartCurrentWorkingHours: 40,
    ttrStartAdjustedWorkingHours: 32,
    ttrStrategy: 1, //1 Match Income, 2 Match Contribution, 3 User Input
    userInputTTRBalance: false, // only applicable on ttrStrategy 2
    userInputTTRDrawdown: false,
    ttrIncomeAdjustment: 1, // percentage of income
    ttrAdditionalIncome: 0,
    ttrOptimalSalarySacrifice: true,
    ttrAdditionalSalarySacrifice: 0, // only on false for ttrOptimalSalarySacrifice
    ttrExtendToRetirement: false,
    ttrApplyMinimumDrawdown: false,
    accumulationReturnsArray: [
        [49, 0.0889],
        [59, 0.0889],
        [60, 0.0889],
    ],
    pensionReturnsArray: [
        [49, 0.0959],
        [59, 0.0959],
        [60, 0.0959],
    ],
    ttrReturnsArray: [
        [49, 0.0889],
        [59, 0.0889],
        [60, 0.0889],
    ],
    insurancePremiumsArray: [
        [15, 0],
        [16, 0],
        [17, 0],
        [18, 0],
        [19, 0],
        [20, 0],
        [21, 0],
        [22, 0],
        [23, 0],
        [24, 0],
        [25, 0],
        [26, 0],
        [27, 0],
        [28, 0],
        [29, 0],
        [30, 0],
        [31, 0],
        [32, 0],
        [33, 0],
        [34, 0],
        [35, 0],
        [36, 0],
        [37, 0],
        [38, 0],
        [39, 0],
        [40, 0],
        [41, 0],
        [42, 0],
        [43, 0],
        [44, 0],
        [45, 0],
        [46, 0],
        [47, 0],
        [48, 0],
        [49, 0],
        [50, 0],
        [51, 0],
        [52, 0],
        [53, 0],
        [54, 0],
        [55, 0],
        [56, 0],
        [57, 0],
        [58, 0],
        [59, 0],
        [60, 0],
        [61, 0],
        [62, 0],
        [63, 0],
        [64, 0],
        [65, 0],
    ],
}

module.exports = {
    sgyConsumer,
}
